import React, { useEffect, useRef } from 'react'
import { CLUDO_ENGINE_ID } from '../../../../utils/constants'
import Expand_left from '@tdcerhverv/parrotfish/dist/icons/Icons/Expand_left.svg'
import Search from '@tdcerhverv/parrotfish/dist/icons/Icons/Search.svg'
import { ISearchMenu } from './SearchMenu.type'
import SearchComponent from '../../../Search'

//MUI Components
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import SvgIcon from '@mui/material/SvgIcon'
import { useTheme } from '@mui/material/styles'
import searchDataDistributor from '../../../../utils/searchDataDistributor'

const SearchMenu = ({ open, handleClose, images, isKundeservicePage }: ISearchMenu) => {
  const { breakpoints, typography } = useTheme()
  const styles = {
    searchMenuControls: {
      display: 'none',
      [breakpoints.down('md')]: {
        display: 'block',
      },
    },
    search: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',

      '& > img': {
        display: 'none',
      },
    },
    title: {
      ...typography.subtitle1,
      display: 'flex',
      alignItems: 'center',
      fontSize: 18,
      fontWeight: 500,
      background: 'none',
      border: 0,
      padding: '0 12px',
      [breakpoints.down('md')]: {
        cursor: 'pointer',
      },
    },
    titleIcon: {
      width: '16px',
      height: '16px',
      marginRight: '10px',
    },
  }
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref.current) return
    const searchField = ref.current.querySelector('#searchTextField') as HTMLDivElement
    if (open) {
      searchField && searchField.focus()
    } else {
      searchField && searchField.blur()
    }
  }, [open])

  // const data = useStaticQuery(graphql`
  //   query Search {
  //     images: contentfulModuleComponentBundle(
  //       contentful_id: { eq: "iGoosu86m6yxjIsnu106N" }
  //     ) {
  //       ...searchDataFragment
  //     }
  //   }
  // `)

  return (
    <div ref={ref}>
      <Box sx={styles.searchMenuControls} mb={5} display="flex" justifyContent="space-between">
        <Typography onClick={() => handleClose && handleClose(false)} component="button" sx={styles.title}>
          <SvgIcon sx={styles.titleIcon} component={Expand_left} viewBox="0 0 48 48" />
          <SvgIcon sx={styles.titleIcon} component={Search} viewBox="0 0 48 48" />
          <span>Søg</span>
        </Typography>
      </Box>
      <SearchComponent
        sx={styles.search}
        searchData={searchDataDistributor(images)}
        headline="Find hvad du søger på tdc.dk"
        engineId={CLUDO_ENGINE_ID || ''}
        basePath={isKundeservicePage ? '/kundeservice' : ''}
        placeholder={isKundeservicePage ? 'Søg på hjælpesiderne' : 'Søg'}
      />
    </div>
  )
}

export default SearchMenu
